import React from "react";
import { Image } from "antd";
import NoImage from "../../assets/No image.png";

const ImagePreview = (props) => {
  const { width, height, src, style } = props;

  return (
    <img
      width={width}
      height={height}
      src={src || NoImage}
      style={style}
      onClick={(e) => e.stopPropagation()}
    />
  );
};

export default ImagePreview;
